export enum AppRoute {
  LOGIN = "/login",
  HOME = "/home",
  PAYMENTS = "/payments",
  TRIAL = "/trial",
  VISITS = "/visits",
  TAX = "/tax",
  PAYMENT_METHODS_LIST = "/payment-methods/list",
  CARD_ONBOARDING = "/payment-methods/new-card-onboarding",
  RECEIPT_SUBMIT = "/receipt/submit",
  MILEAGE_SUBMIT = "/mileage/submit",
  TAX_ONBOARDING = "/tax/onboarding",
}
